import { FC, Fragment, useState } from "react";
import { Send } from "@mui/icons-material";

import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, IContract } from "@framework/types";
import VestingTransferOwnershipABI from "@framework/abis/json/Ownable/transferOwnership.json";

import { AccountDialog, IAccountDto } from "../../../../dialogs/account";

interface IVestingTransferOwnershipButtonProps {
  className?: string;
  disabled?: boolean;
  variant?: ListActionVariant;
  vesting: IContract;
}

export const VestingTransferOwnershipButton: FC<IVestingTransferOwnershipButtonProps> = props => {
  const { className, disabled, variant, vesting } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const [isTransferOwnershipDialogOpen, setIsTransferOwnershipDialogOpen] = useState(false);

  const { execute: metaFn } = useMetamask(async (dto: IAccountDto) => {
    return writeContractAsync({
      address: vesting.address as AddressType,
      abi: VestingTransferOwnershipABI,
      functionName: "transferOwnership",
      args: [dto.account],
    });
  });

  const handleTransferOwnership = (): void => {
    setIsTransferOwnershipDialogOpen(true);
  };

  const handleTransferOwnershipConfirm = async (dto: IAccountDto) => {
    await metaFn(dto).finally(() => {
      setIsTransferOwnershipDialogOpen(false);
    });
  };

  const handleTransferOwnershipCancel = () => {
    setIsTransferOwnershipDialogOpen(false);
  };

  return (
    <Fragment>
      <ListAction
        onClick={handleTransferOwnership}
        icon={Send}
        message="form.tips.transferOwnership"
        className={className}
        dataTestId="VestingTransferOwnershipButton"
        disabled={disabled}
        variant={variant}
      />
      <AccountDialog
        onConfirm={handleTransferOwnershipConfirm}
        onCancel={handleTransferOwnershipCancel}
        open={isTransferOwnershipDialogOpen}
        message="dialogs.transferOwnership"
        testId="VestingTransferOwnershipDialogForm"
        initialValues={{
          account: "",
        }}
      />
    </Fragment>
  );
};
